import React from 'react';
import {TSectionList} from 'modules/timeline';
import {JAVASCRIPT_VOID} from 'constants/config';
import {convertSecondToTime} from 'lib/utils';
import {t} from 'lib/i18n';

/**
 * 편집 구간 선택 컴포넌트
 */

interface ISection {
  sectionTitle: {
    idx: number;
    time: number;
  };
  sectionLists: TSectionList[];
  listsClass: string;
  onClickSectionList: (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  ) => void;
  onClickSection: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}

const Section = ({
  sectionTitle,
  sectionLists,
  listsClass,
  onClickSectionList,
  onClickSection,
}: ISection) => {
  return (
    <div className='scene'>
      <span>{t('편집 구간 선택')}</span>
      <div>
        {/* <!-- 2019-1210 on 클레스 추가시 UL 출력됨  , off 클레스 추가시 비활성화 상태--> */}
        <a
          href={JAVASCRIPT_VOID}
          className={listsClass}
          onClick={onClickSectionList}
          data-name='section'>
          {t('장면 {{sectionTitle}}', {
            placeholder: {sectionTitle: sectionTitle.idx + 1},
          })}{' '}
          {`${convertSecondToTime(sectionTitle.time)}`}
        </a>
        <ul>
          {sectionLists.map((val, idx) => (
            <li key={idx}>
              <a
                href={JAVASCRIPT_VOID}
                className='section'
                data-idx={idx}
                data-name='section'
                onClick={onClickSection}>
                {t('장면 {{idx}}', {placeholder: {idx: idx + 1}})} (
                {`${convertSecondToTime(val.endTime)}`})
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Section;
